module.exports = __webpack_public_path__ + "static/media/photo2.d01079a6.png";